import React from "react";
import { Box } from "@mui/material";

const CustomFooter = ({ text, isFixed, marginTop = "15vh" }) => {
  return (
    <div>
      <Box
        sx={{
          position: isFixed ? "fixed" : "relative",
          left: 0,
          right: 0,
          bottom: 0,
          marginTop,
          backgroundColor: "#A92027",
          color: "white",
          textAlign: "center",
          fontSize: { xs: "0.75rem", sm: "1rem" },
          p: 2,
        }}
      >
        {text}
      </Box>
    </div>
  );
};

export default CustomFooter;
